import React from "react";
import t from "module/translations";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const TrainingCustomAssigneeTableHead: React.FC = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell align="left">
          {t.competencyManagement.trainingCustom.assignee.staffHeader}
        </TableCell>
        <TableCell align="left">
          {t.competencyManagement.trainingCustom.assignee.achievedHeader}
        </TableCell>
        <TableCell align="left">
          {t.competencyManagement.trainingCustom.assignee.remarksHeader}
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default React.memo(TrainingCustomAssigneeTableHead);
